import { render } from "./payrollitems-modal.vue?vue&type=template&id=19ccfff8"
import script from "./payrollitems-modal.vue?vue&type=script&lang=js"
export * from "./payrollitems-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__